import { k as ensure_array_like, e as escape_html, c as attr_class, f as clsx, p as pop, a as push } from "../../../../../chunks/index2.js";
import "@sveltejs/kit/internal";
import "../../../../../chunks/exports.js";
import "../../../../../chunks/utils.js";
import "../../../../../chunks/state.svelte.js";
import { g as getToastState } from "../../../../../chunks/Toast.svelte.js";
function _page($$payload, $$props) {
  push();
  const { data } = $$props;
  const order = data.order;
  getToastState();
  function formatDate(date) {
    return new Date(date).toLocaleDateString("en-KE", { year: "numeric", month: "long", day: "numeric" });
  }
  if (order) {
    $$payload.out.push("<!--[-->");
    const each_array = ensure_array_like(order.ProductOnOrder);
    $$payload.out.push(`<div class="container mx-auto px-4 py-8"><div class="mb-8 flex items-center gap-4"><a href="/purchases" class="rounded-md bg-gray-100 px-4 py-2 text-sm transition-colors hover:bg-gray-200">← Back to Orders</a> <h1 class="text-3xl font-bold">Order #${escape_html(order.id)}</h1></div> <div class="grid gap-8 md:grid-cols-3"><div class="md:col-span-2"><div class="rounded-md border p-6"><h2 class="mb-4 text-xl font-semibold">Order Details</h2> <div class="grid gap-4 sm:grid-cols-2"><div><p class="text-sm text-gray-500">Order Date</p> <p class="font-medium">${escape_html(formatDate(order.createdAt))}</p></div> <div><p class="text-sm text-gray-500">Status</p> <p class="font-medium capitalize">${escape_html(order.status.toLowerCase())}</p></div></div></div> <div class="mt-8 rounded-md border p-6"><h2 class="mb-4 text-xl font-semibold">Products</h2> <div class="space-y-4"><!--[-->`);
    for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
      let product = each_array[$$index];
      $$payload.out.push(`<div class="rounded-md border p-4"><div class="flex items-center justify-between"><div><h3 class="font-semibold">${escape_html(product.product.name)}</h3> <p class="text-sm text-gray-600">Quantity: ${escape_html(product.quantity)}</p> <p class="mt-1 text-sm">Issued Status: <span${attr_class(clsx(product.isIssued ? "text-green-600" : "text-orange-600"))}>${escape_html(product.isIssued ? "Issued" : "Pending")}</span></p></div> <div class="text-right"><p class="font-semibold">KES ${escape_html((product.product.price * product.quantity).toLocaleString())}</p></div></div></div>`);
    }
    $$payload.out.push(`<!--]--></div></div></div></div></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
    $$payload.out.push(`<div class="container mx-auto px-4 py-8"><h1 class="text-3xl font-bold">Order not found</h1></div>`);
  }
  $$payload.out.push(`<!--]-->`);
  pop();
}
export {
  _page as default
};
